module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-31.46d9e37b.png";